import React, { useState, useEffect } from 'react';
import { path, propOr, isEmpty } from 'ramda';
import { useQuery } from '@apollo/react-hooks';
import { GET_JOBS } from '../apollo/queries';
import {
  Page,
  Layout,
  Avatar,
  TextStyle,
  Button,
  Card,
  ResourceItem,
  ResourceList,
  EmptyState,
  AppProvider,
  Subheading,
} from '@shopify/polaris';
import '@shopify/polaris/dist/styles.css';

const img = 'https://cdn.shopify.com/s/files/1/0757/9955/files/empty-state.svg';

const Proxy = (props) => {
  let { shopifyToken, path_url } = props;

  const { loading, data, refetch } = useQuery(GET_JOBS, {
    variables: { shopifyToken, templates: false },
  });

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const jobList = propOr([], 'jobs')(data);
  const jobs = propOr([], 'jobs')(jobList);
  const allAccess = propOr(null, 'allAccess')(jobList);
  const changeRoute = path(['history', 'push'])(props);

  const allJobs = jobs.map((item) => [...Object.values(item).splice(-1, 1)]);

  if (jobs.length === 0 && !loading) {
    return (
      <AppProvider>
        <Layout>
          <EmptyState
            heading='Manage your job postings'
            action={{ content: 'Open Job', onAction: () => changeRoute('/set-job') }}
            secondaryAction={{ content: 'Learn more', url: 'https://help.shopify.com' }}
            image={img}>
            <p>Open jobs and start receiving applications from job seekers.</p>
          </EmptyState>
        </Layout>
      </AppProvider>
    );
  }

  return (
    <AppProvider>
      <Page title='Our job openings'>
        <Layout.Section>
          <Card>
            <ResourceList
              resourceName={{ singular: 'customer', plural: 'customers' }}
              items={jobs}
              renderItem={(item) => {
                const { id, title, location, category, updatedAt, employmentType } = item;
                return (
                  <ResourceItem title={title} accessibilityLabel={`View details for ${title}`}>
                    <h3>
                      <TextStyle variation='strong'>{title}</TextStyle>
                    </h3>
                    <div>
                      {location}, {category}, {employmentType}
                    </div>
                    <Button onClick={() => changeRoute(`${path_url}/jobs/${id}`)} size='small'>
                      Apply
                    </Button>
                  </ResourceItem>
                );
              }}
            />
          </Card>
        </Layout.Section>
      </Page>
    </AppProvider>
  );
};

export default Proxy;
